import { PageHeader } from '@v2/design-system';
import { Link } from 'react-router-dom';

const STEPS = [
    { id: 'step1', title: '1º e-mail — Aprovação', subtitle: 'Disparado na aprovação da comissão (dia 0)' },
    { id: 'step2', title: '2º e-mail — Lembrete', subtitle: 'Disparado automaticamente no 5º dia' },
    { id: 'step3', title: '3º e-mail — Urgente', subtitle: 'Disparado automaticamente no 12º dia (último aviso)' },
    { id: 'manual', title: 'Cobrança manual', subtitle: 'Disparado pelo financeiro via botão em lote' },
    { id: 'nf_received', title: 'NF recebida - Documento OK', subtitle: 'Disparado quando o vendedor envia a NF com sucesso' },
    { id: 'period_rescheduled', title: 'Comissão reagendada', subtitle: 'Disparado quando a NF não chega no prazo — novo período + CTA para enviar NF' },
] as const;

export default function CommissionNfEmailPreviewPage() {
    return (
        <div className="space-y-6">
            <PageHeader
                title="Preview — E-mails de NF"
                subtitle="Modelos enviados ao vendedor após aprovação da comissão"
            >
                <Link
                    to="/commissioning/records?status=awaiting_nf"
                    className="inline-flex items-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                    Voltar aos registros
                </Link>
            </PageHeader>

            <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
                Pagamento somente mediante NF. Prazo padrão: 15 dias. Sem NF no prazo, a comissão vai para o próximo período de pagamento.
            </div>

            <div className="space-y-8">
                {STEPS.map((step) => (
                    <section key={step.id} className="space-y-2">
                        <div>
                            <h2 className="text-lg font-semibold text-gray-900">{step.title}</h2>
                            <p className="text-sm text-gray-500">{step.subtitle}</p>
                        </div>
                        <div className="rounded-xl border border-gray-200 overflow-hidden bg-gray-100">
                            <iframe
                                title={step.title}
                                src={`/api/v2/commissioning/nf-email-preview/${step.id}`}
                                className="w-full bg-white"
                                style={{ minHeight: 720 }}
                            />
                        </div>
                    </section>
                ))}
            </div>
        </div>
    );
}
